import React, { Suspense } from "react";
import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { HeroSection } from "@/components/marketing/HeroSection";
import { StickyMobileCTA } from "@/components/marketing/StickyMobileCTA";
import { SectionDivider } from "@/components/marketing/SectionDivider";

const FeaturedInSection = React.lazy(() => import("@/components/marketing/FeaturedInSection").then(m => ({ default: m.FeaturedInSection })));
const FeaturedPodcastersSection = React.lazy(() => import("@/components/marketing/FeaturedPodcastersSection").then(m => ({ default: m.FeaturedPodcastersSection })));
const ValuePropsSection = React.lazy(() => import("@/components/marketing/ValuePropsSection").then(m => ({ default: m.ValuePropsSection })));
const StatsSection = React.lazy(() => import("@/components/marketing/StatsSection").then(m => ({ default: m.StatsSection })));
const HowItWorksSection = React.lazy(() => import("@/components/marketing/HowItWorksSection").then(m => ({ default: m.HowItWorksSection })));
const FeaturesSection = React.lazy(() => import("@/components/marketing/FeaturesSection").then(m => ({ default: m.FeaturesSection })));
const PricingPreview = React.lazy(() => import("@/components/marketing/PricingPreview").then(m => ({ default: m.PricingPreview })));
const TestimonialsSection = React.lazy(() => import("@/components/marketing/TestimonialsSection").then(m => ({ default: m.TestimonialsSection })));
const FinalCTASection = React.lazy(() => import("@/components/marketing/FinalCTASection").then(m => ({ default: m.FinalCTASection })));
const MarketingFooter = React.lazy(() => import("@/components/marketing/MarketingFooter").then(m => ({ default: m.MarketingFooter })));

const Index = () => {
  return (
    <div className="min-h-screen">
      <MarketingHeader />
      <main id="main-content">
        <HeroSection />
        <Suspense fallback={null}>
          <FeaturedInSection />
          <FeaturedPodcastersSection />
          <SectionDivider className="bg-primary" variant="subtle" />
          <ValuePropsSection />
          <SectionDivider className="bg-primary" variant="accent" />
          <StatsSection />
          <HowItWorksSection />
          <SectionDivider className="bg-secondary" variant="accent" />
          <FeaturesSection />
          <PricingPreview />
          <TestimonialsSection />
          <FinalCTASection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <MarketingFooter />
      </Suspense>
      <StickyMobileCTA />
    </div>
  );
};

export default Index;